
import React from 'react';
import { AnimatedSection } from '@/hooks/useScrollAnimation';
import { useParallax } from '@/hooks/useParallax';
import scopoBackground from '@/assets/clinica-cirurgia-plastica-curitiba.webp';


const ClinicSection: React.FC = () => {
  const { ref: parallaxRef } = useParallax({ speed: 0.2, targetSelector: '[data-parallax-target]' });

  return (
    <section id="diferenciais" aria-labelledby="clinic-title" ref={parallaxRef} className="section-spacing relative overflow-hidden">
      {/* Background com parallax */}
      <div
        data-parallax-target
        className="absolute inset-0 will-change-transform overflow-hidden"
        aria-hidden="true"
      >
        <picture>
          <img
            src={scopoBackground}
            alt=""
            aria-hidden="true"
            className="w-full h-full object-cover object-[right_center] md:object-[left_center]"
            loading="lazy"
            decoding="async"
            width="1920"
            height="960"
            sizes="100vw"
          />
        </picture>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/4 left-0 w-[400px] h-[400px] decorative-blur decorative-blur-primary opacity-15" aria-hidden="true" />

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <AnimatedSection>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

            {/* Coluna vazia — mantém o card à direita */}
            <div className="hidden lg:block" aria-hidden="true" />

            {/* Card com o texto */}
            <article className="space-y-6 bg-dark-base/85 backdrop-blur-sm rounded-2xl p-8 border border-white/8">
              <header>
                <p className="subtitle-wide text-gold mb-3">Por que me escolher</p>
                <h2 id="clinic-title" className="text-3xl md:text-4xl text-light-primary tracking-tight leading-tight">
                  Cirurgião plástico em Curitiba com atuação em mama e contorno corporal
                </h2>
              </header>

              <div className="space-y-4 text-light-muted leading-relaxed text-sm md:text-base">
                <p>
                  Minha atuação em cirurgia plástica é guiada por uma abordagem baseada em <strong className="text-light-primary">planejamento individualizado, avaliação criteriosa</strong> e respeito às características de cada paciente.
                </p>
                <p>
                  Cada cirurgia começa com uma análise detalhada da anatomia, das expectativas e do momento de vida de quem me procura. A partir dessa avaliação, definimos juntos a estratégia cirúrgica mais adequada, sempre priorizando segurança e resultados naturais.
                </p>
                <p>
                  Grande parte do meu trabalho está focada em <strong className="text-light-primary">cirurgias das mamas, contorno corporal e remodelamento após grandes emagrecimentos</strong>, procedimentos que exigem compreensão cuidadosa das proporções do corpo e indicação técnica precisa.
                </p>
                <p>
                  Ao longo de toda a jornada cirúrgica, procuro manter uma comunicação clara e acessível, explicando cada etapa do processo e acompanhando de perto o período pós-operatório para garantir uma recuperação segura e tranquila.
                </p>
              </div>
            </article>

          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default ClinicSection;
